import React from 'react';
import st from './styles.module.scss';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'antd';

const TopBar = () => {
  const { t } = useTranslation();
  const getNavLinkClassName = isActive =>
    `nav-link ${st.topBarLink} ${isActive ? st.topBarActiveLink : 'text-muted'}`;
  return (
    <div className={st.topBarContainer}>
      <div className={`container ${st.topBar}`}>
        <div>
          <ul className={st.topBarList}>
            <li>
              <NavLink className={({ isActive }) => getNavLinkClassName(isActive)} to="/">
                {t('forEmployees')}
              </NavLink>
            </li>
            <li>
              <NavLink className={({ isActive }) => getNavLinkClassName(isActive)} to="/employers">
                {t('forEmployers')}
              </NavLink>
            </li>
          </ul>
        </div>
        <NavLink to="/faq" target="_blank" className={st.topBarFAQLink}>
          <Tooltip title={t('FAQ.tooltip')} color="rgba(0, 0, 0, .7)" placement={'left'}>
            <span>FAQ</span>
          </Tooltip>
        </NavLink>
      </div>
    </div>
  );
};

export default TopBar;
